import React from 'react';
import { View, TouchableWithoutFeedback } from 'react-native';

import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import styles from '../styles';

function ModeOption({ theme, selected, onPress, colStyles, text }) {
  return (
    <TouchableWithoutFeedback testID={text} onPress={onPress}>
      <View
        style={[styles.col(theme), selected && styles.colSelected(theme)].concat(colStyles)}
        testID={FrameworkTestKeys.displayOptionModeOptionView}
      >
        <VFText
          type={selected ? 'secondary' : 'primary'}
          i18nKey={text}
          style={styles.text}
          testKey={FrameworkTestKeys.displayOptionModeOptionText}
        />
      </View>
    </TouchableWithoutFeedback>
  );
}

ModeOption.defaultProps = {
  theme: LightThemeColors,
};

ModeOption.propTypes = {
  theme: PropTypes.object,
  selected: PropTypes.bool.isRequired,
  onPress: PropTypes.func.isRequired,
  colStyles: PropTypes.array.isRequired,
  text: PropTypes.string.isRequired,
};

export default ModeOption;
